export const projectsData =[
    {
        id: 1,
        projectName: 'Book Market',
        projectDesc: 'Integrated OAuth authentication email and used firebase JWT Token verification.Node.js backend with Express.js to create Rest-API for getting data from MongoDBdatabase and Stripe payment for checkout. Admin, buyer, and seller management roles for different routes.',
        tags: ['HTML5, React.js, Tailwind CSS, Node.js, Express.js, Stripe, JWT token'],
        live_link:'https://oneline-resale-market.web.app/',
        code: 'https://github.com/bipul-hossein/resale_book_market',
        demo: 'https://historythroughmovies.pythonanywhere.com/',
        image: "https://user-images.githubusercontent.com/85482640/161571651-35ab8e4e-dc57-4834-bafc-9485766f5b8a.png",
        feather:[
            "Integrated OAuth authentication email and used firebase JWT Token verification.",
            "Node.js backend with Express.js to create Rest-API for getting data from MongoDBdatabase and Stripe payment for checkout." ,
            "Admin, buyer, and seller management roles for different routes."
        ]
    },
    {
        id: 2,
        projectName: 'Dr. Robert Fujii',
        projectDesc: 'User account OAuth authentication using firebase with JWT Token verificationIntegrated user location using React Leaflet.Navigate users to services like available courses, FAQ, Blog, and checkout using react-router-dom.',
        tags: ['HTML5, React.js, Tailwind CSS, Node.js, Express.js, JWT token'],
        live_link:'https://service-review-assign11.firebaseapp.com/',
        code: 'https://github.com/bipul-hossein/dentists_sevice_client',
        demo: 'https://practical-meninsky-36f305.netlify.app/',
        image: "https://camo.githubusercontent.com/f9fbe30b577cff2fbf09af53fb3c1f12fcc10a771bf9459ed5af10bffab9e38b/68747470733a2f2f6d69726f2e6d656469756d2e636f6d2f6d61782f3837352f312a525f5f63646e384c316759474b3154647171797562672e706e67",
        feather:[
            "User account OAuth authentication using firebase with JWT Token","verificationIntegrated user location using React Leaflet." ,
            "Navigate users to services like available courses, FAQ, Blog, and checkout using react-router-dom."
        ]
    },
    {
        id: 3,
        projectName: 'SKILL HUNT',
        projectDesc: 'Implemented primary OAuth email, google, and GitHub authentication using firebase for users accounts. Node.js backend with Express.js to create Rest-API for getting data from the MongoDBserver.React Router Dom to navigate users to routes like creating service, viewing service details,and leaving a review for the specific service.',
        tags: ['HTML5, React.js, Tailwind CSS, Node.js, Express.js,'],
        live_link:'https://education-site-assign.web.app/',
        code: 'https://github.com/bipul-hossein/skill_hunt_client',
        demo: 'https://educative-clone.vercel.app/',
        image: "https://user-images.githubusercontent.com/85482640/161571651-35ab8e4e-dc57-4834-bafc-9485766f5b8a.png",
        feather:[
            "Implemented primary OAuth email, google, and GitHub authentication using firebase for users accounts.",
            " Node.js backend with Express.js to create Rest-API for getting data from the MongoDBserver",
            "React Router Dom to navigate users to routes like creating service, viewing service details,and leaving a review for the specific service."
        ]
    },
]